/**
 * ANGOL keresonevek a magyar emoji-keszlethez.
 *
 * ─── Miert kulon fajl? ──────────────────────────────────────────────────────
 *
 * A keszlet (`data/emoji.ts`) magyarul keres, es ez szandekos: aki "kutya"-t
 * ir be, annak nem segit, hogy a jel neve `dog face`. Ez viszont nem zarja ki
 * a masik iranyt - aki mashol megszokta a `:joy:` vagy a `:salute:` alakot,
 * annak ne kelljen ujratanulnia a keszletet.
 *
 * A ketto tehat NEM verseng: a magyar nev a jel neve (az latszik a listaban),
 * az angol csak egy masodik ut ugyanoda. Kulon fajlban all, hogy a magyar
 * keszlet olvashato maradjon, es hogy latszodjon: ez alias-reteg, nem forras.
 *
 * A nevek a bevett (GitHub/Slack) rovidnevek. Ahol tobb elterjedt alak van,
 * mind szerepel - a `+1` es a `thumbsup` ugyanarra mutat.
 *
 * A kulcs a JEL maga, igy a magyar keszletbe nem kell hozzanyulni. Ami itt
 * nem szerepel, az magyarul tovabbra is megtalalhato.
 */
export const EMOJI_ALIASES: Record<string, string> = {
  // ─── Gyakori ───────────────────────────────────────────────────────────────
  '👍': 'thumbsup|+1|thumbs up|like',
  '👎': 'thumbsdown|-1|thumbs down|dislike',
  '✅': 'white check mark|check|done',
  '❌': 'x|cross mark|no',
  '❤️': 'heart|red heart|love',
  '🎉': 'tada|party popper|celebrate',
  '👀': 'eyes|looking',
  '🙏': 'pray|folded hands|thanks|please',
  '🔥': 'fire|lit',
  '💡': 'bulb|light bulb|idea',
  '🤔': 'thinking|thinking face|hmm',
  '⚠️': 'warning|caution',
  '🚀': 'rocket|launch|ship it',
  '⏳': 'hourglass|hourglass flowing sand|waiting',
  '📌': 'pushpin|pin',
  '🆗': 'ok|ok button',
  '😂': 'joy|tears of joy|lol|laughing tears',
  '🙌': 'raised hands|hooray|praise',
  '💪': 'muscle|flexed biceps|strong',
  '👏': 'clap|clapping hands|applause',
  '🤝': 'handshake|deal|agreement',
  '🫡': 'salute|saluting face|yes sir',

  // ─── Arcok es hangulat ─────────────────────────────────────────────────────
  '😀': 'grinning|grinning face',
  '😃': 'smiley|grinning face with big eyes',
  '😄': 'smile|grinning face with smiling eyes',
  '😁': 'grin|beaming face',
  '😆': 'laughing|satisfied|xd',
  '😅': 'sweat smile|grinning face with sweat',
  '🤣': 'rofl|rolling on the floor laughing|lmao',
  '😊': 'blush|smiling face with smiling eyes',
  '🙂': 'slightly smiling face|slight smile',
  '🙃': 'upside down face|upside down',
  '😉': 'wink|winking face',
  '😌': 'relieved',
  '😍': 'heart eyes|smiling face with heart eyes',
  '🥰': 'smiling face with hearts|in love',
  '😘': 'kissing heart|face blowing a kiss',
  '😗': 'kissing',
  '😙': 'kissing smiling eyes',
  '😚': 'kissing closed eyes',
  '😋': 'yum|face savoring food|delicious',
  '😛': 'stuck out tongue|tongue out',
  '😜': 'stuck out tongue winking eye|winking tongue',
  '🤪': 'zany face|crazy|goofy',
  '😝': 'stuck out tongue closed eyes',
  '🤑': 'money mouth face|money face',
  '🤗': 'hugging face|hug',
  '🤭': 'face with hand over mouth|giggle',
  '🤫': 'shushing face|shush|quiet',
  '🤐': 'zipper mouth face|zip it',
  '🤨': 'face with raised eyebrow|skeptical',
  '😐': 'neutral face|neutral',
  '😑': 'expressionless',
  '😶': 'no mouth|face without mouth',
  '😏': 'smirk|smirking face',
  '😒': 'unamused',
  '🙄': 'roll eyes|face with rolling eyes|eyeroll',
  '😬': 'grimacing|grimace',
  '🤥': 'lying face|liar',
  '😔': 'pensive',
  '😪': 'sleepy',
  '🤤': 'drooling face|drool',
  '😴': 'sleeping|asleep',
  '😷': 'mask|face with medical mask',
  '🤒': 'face with thermometer|sick',
  '🤕': 'face with head bandage|injured',
  '🤢': 'nauseated face|sick',
  '🤮': 'vomiting|face vomiting|puke',
  '🤧': 'sneezing face|sneeze',
  '🥵': 'hot face|overheated',
  '🥶': 'cold face|freezing',
  '🥴': 'woozy face|tipsy',
  '😵': 'dizzy face|knocked out',
  '🤯': 'exploding head|mind blown',
  '🤠': 'cowboy hat face|cowboy',
  '🥳': 'partying face|party',
  '😎': 'sunglasses|smiling face with sunglasses|cool',
  '🤓': 'nerd face|nerd',
  '🧐': 'monocle|face with monocle',
  '😕': 'confused',
  '😟': 'worried',
  '🙁': 'slightly frowning face|slight frown',
  '☹️': 'frowning face|frown',
  '😮': 'open mouth|wow',
  '😯': 'hushed',
  '😲': 'astonished',
  '😳': 'flushed|embarrassed',
  '🥺': 'pleading face|puppy eyes',
  '😦': 'frowning with open mouth',
  '😧': 'anguished',
  '😨': 'fearful|scared',
  '😰': 'anxious with sweat|cold sweat',
  '😥': 'sad but relieved face|disappointed relieved',
  '😢': 'cry|crying face|sad',
  '😭': 'sob|loudly crying face|bawling',
  '😱': 'scream|screaming in fear',
  '😖': 'confounded',
  '😣': 'persevere',
  '😞': 'disappointed',
  '😓': 'downcast with sweat|sweat',
  '😩': 'weary',
  '😫': 'tired face|tired',
  '🥱': 'yawning face|yawn',
  '😤': 'triumph|face with steam from nose|huff',
  '😡': 'rage|pouting face|mad',
  '😠': 'angry|angry face',
  '🤬': 'cursing|face with symbols on mouth|swearing',
  '😇': 'innocent|smiling face with halo|angel',
  '🥲': 'smiling face with tear',
  '🫠': 'melting face|melting',
  '🫥': 'dotted line face|invisible',
  '😈': 'smiling imp|devil',
  '👿': 'imp|angry devil',
  '💀': 'skull|dead',
  '☠️': 'skull and crossbones',
  '💩': 'poop|pile of poo|hankey',
  '🤡': 'clown face|clown',
  '👹': 'japanese ogre|ogre',
  '👻': 'ghost',
  '👽': 'alien|extraterrestrial',
  '🤖': 'robot|bot',
  '😺': 'smiley cat|grinning cat',
  '😸': 'smile cat|grinning cat with smiling eyes',
  '😹': 'joy cat|cat with tears of joy',
  '😻': 'heart eyes cat|smiling cat with heart eyes',
  '😼': 'smirk cat|cat with wry smile',
  '🙀': 'scream cat|weary cat',
  '😿': 'crying cat face|crying cat',
  '😾': 'pouting cat',
  '🎃': 'jack o lantern|halloween|pumpkin',

  // ─── Kez es ember ──────────────────────────────────────────────────────────
  '👋': 'wave|waving hand|hello|bye',
  '🤚': 'raised back of hand',
  '🖐️': 'hand with fingers splayed',
  '✋': 'raised hand|stop|high five',
  '🖖': 'vulcan salute|spock',
  '👌': 'ok hand|perfect',
  '🤌': 'pinched fingers',
  '🤏': 'pinching hand|small',
  '✌️': 'v|victory hand|peace',
  '🤞': 'crossed fingers|fingers crossed',
  '🫰': 'finger heart|hand with index finger and thumb crossed',
  '🤟': 'love you gesture',
  '🤘': 'metal|sign of the horns|rock on',
  '🤙': 'call me hand|shaka',
  '👈': 'point left',
  '👉': 'point right',
  '👆': 'point up 2',
  '👇': 'point down',
  '☝️': 'point up|index pointing up',
  '✊': 'fist|raised fist',
  '👊': 'punch|oncoming fist|fist bump',
  '🤛': 'left facing fist',
  '🤜': 'right facing fist',
  '🫶': 'heart hands',
  '✍️': 'writing hand|writing',
  '💅': 'nail care|nail polish',
  '🤳': 'selfie',
  '💄': 'lipstick',
  '🦾': 'mechanical arm',
  '🦿': 'mechanical leg',
  '🦵': 'leg',
  '🦶': 'foot',
  '👂': 'ear',
  '🦻': 'ear with hearing aid',
  '👃': 'nose',
  '🧠': 'brain',
  '🫀': 'anatomical heart',
  '🫁': 'lungs',
  '🦷': 'tooth',
  '🦴': 'bone',
  '👁️': 'eye',
  '👅': 'tongue',
  '👄': 'lips|mouth',
  '👶': 'baby',
  '🧒': 'child|kid',
  '👦': 'boy',
  '👧': 'girl',
  '🧑': 'person|adult',
  '👱': 'blond haired person|blond',
  '👨': 'man',
  '🧔': 'bearded person|beard',
  '👩': 'woman',
  '🧓': 'older person',
  '👴': 'older man|grandpa',
  '👵': 'older woman|grandma',
  '🙍': 'person frowning',
  '🙎': 'person pouting',
  '🙅': 'no good|person gesturing no',
  '🙆': 'ok woman|person gesturing ok',
  '💁': 'information desk person|tipping hand',
  '🙋': 'raising hand|volunteer',
  '🧏': 'deaf person',
  '🙇': 'bow|person bowing|sorry',
  '🤦': 'facepalm|face palm',
  '🤷': 'shrug|no idea',
  '👮': 'police officer|cop',
  '🕵️': 'detective|spy',
  '💂': 'guard',
  '👷': 'construction worker',
  '🤴': 'prince',
  '👸': 'princess',
  '👰': 'bride|person with veil',
  '🤵': 'person in tuxedo|groom',
  '🎅': 'santa|santa claus',
  '🦸': 'superhero',
  '🦹': 'supervillain',
  '🧙': 'mage|wizard',
  '🧚': 'fairy',
  '🧛': 'vampire',
  '👨‍⚕️': 'man health worker|male doctor',
  '👩‍⚕️': 'woman health worker|female doctor',
  '👨‍🌾': 'man farmer',
  '👩‍🌾': 'woman farmer',
  '👨‍🍳': 'man cook|male chef',
  '👩‍🍳': 'woman cook|female chef',
  '👨‍💻': 'man technologist|male programmer|developer',
  '👩‍💻': 'woman technologist|female programmer|developer',
  '👨‍🔧': 'man mechanic',
  '👩‍🔬': 'woman scientist',
  '👨‍🏫': 'man teacher',
  '👩‍🏫': 'woman teacher',
  '🚶': 'walking|person walking',
  '🏃': 'runner|person running',
  '💃': 'dancer|woman dancing',
  '🕺': 'man dancing',
  '🧘': 'person in lotus position|yoga|meditation',
  '🛌': 'person in bed',
  '👪': 'family',
  '🫂': 'people hugging|hug',

  // ─── Allatok ───────────────────────────────────────────────────────────────
  '🐶': 'dog|dog face|puppy',
  '🐕': 'dog2',
  '🦮': 'guide dog',
  '🐕‍🦺': 'service dog',
  '🐩': 'poodle',
  '🐺': 'wolf',
  '🦊': 'fox',
  '🦝': 'raccoon',
  '🐱': 'cat|cat face|kitty',
  '🐈': 'cat2',
  '🐈‍⬛': 'black cat',
  '🦁': 'lion',
  '🐯': 'tiger|tiger face',
  '🐅': 'tiger2',
  '🐆': 'leopard',
  '🐴': 'horse|horse face',
  '🐎': 'racehorse',
  '🦄': 'unicorn',
  '🦓': 'zebra',
  '🦌': 'deer',
  '🐮': 'cow|cow face',
  '🐄': 'cow2',
  '🐂': 'ox',
  '🐃': 'water buffalo',
  '🐷': 'pig|pig face',
  '🐖': 'pig2',
  '🐗': 'boar',
  '🐏': 'ram',
  '🐑': 'sheep|ewe',
  '🐐': 'goat',
  '🐪': 'dromedary camel|camel',
  '🦙': 'llama',
  '🦒': 'giraffe',
  '🐘': 'elephant',
  '🦏': 'rhinoceros|rhino',
  '🦛': 'hippopotamus|hippo',
  '🐭': 'mouse|mouse face',
  '🐁': 'mouse2',
  '🐀': 'rat',
  '🐹': 'hamster',
  '🐰': 'rabbit|bunny',
  '🐇': 'rabbit2',
  '🐿️': 'chipmunk|squirrel',
  '🦔': 'hedgehog',
  '🦇': 'bat',
  '🐻': 'bear',
  '🐨': 'koala',
  '🐼': 'panda',
  '🦥': 'sloth',
  '🦦': 'otter',
  '🦨': 'skunk',
  '🦘': 'kangaroo',
  '🐔': 'chicken',
  '🐓': 'rooster',
  '🐣': 'hatching chick',
  '🐤': 'baby chick',
  '🐦': 'bird',
  '🐧': 'penguin',
  '🕊️': 'dove',
  '🦅': 'eagle',
  '🦆': 'duck',
  '🦢': 'swan',
  '🦉': 'owl',
  '🦜': 'parrot',
  '🐸': 'frog',
  '🐊': 'crocodile',
  '🐢': 'turtle',
  '🦎': 'lizard',
  '🐍': 'snake',
  '🐲': 'dragon face|dragon',
  '🐳': 'whale',
  '🐬': 'dolphin',
  '🐟': 'fish',
  '🐠': 'tropical fish',
  '🦈': 'shark',
  '🐙': 'octopus',
  '🐚': 'shell|spiral shell',
  '🦀': 'crab',
  '🦐': 'shrimp',
  '🐌': 'snail',
  '🦋': 'butterfly',
  '🐛': 'bug|caterpillar',
  '🐜': 'ant',
  '🐝': 'bee|honeybee',
  '🐞': 'lady beetle|ladybug',
  '🕷️': 'spider',
  '🦠': 'microbe|germ',
  '🐾': 'paw prints|feet',

  // ─── Termeszet es idojaras ─────────────────────────────────────────────────
  '💐': 'bouquet',
  '🌸': 'cherry blossom|sakura',
  '🌹': 'rose',
  '🌺': 'hibiscus',
  '🌻': 'sunflower',
  '🌼': 'blossom|daisy',
  '🌷': 'tulip',
  '🌱': 'seedling|sprout',
  '🪴': 'potted plant',
  '🌲': 'evergreen tree|pine',
  '🌳': 'deciduous tree|tree',
  '🌴': 'palm tree',
  '🌵': 'cactus',
  '🌾': 'sheaf of rice|ear of rice',
  '🍀': 'four leaf clover|luck',
  '🍁': 'maple leaf',
  '🍂': 'fallen leaf',
  '🍃': 'leaves',
  '🌍': 'earth africa|earth|globe',
  '🌙': 'crescent moon|moon',
  '🌚': 'new moon face',
  '🌝': 'full moon face',
  '⭐': 'star',
  '🌟': 'star2|glowing star',
  '✨': 'sparkles',
  '⚡': 'zap|high voltage|lightning',
  '🔆': 'high brightness|bright',
  '☀️': 'sunny|sun',
  '🌤️': 'sun behind small cloud',
  '⛅': 'partly sunny',
  '☁️': 'cloud',
  '🌧️': 'cloud with rain|rain',
  '⛈️': 'thunder cloud and rain|storm',
  '🌩️': 'cloud with lightning',
  '🌨️': 'cloud with snow|snow',
  '🌪️': 'tornado',
  '🌫️': 'fog',
  '🌬️': 'wind face|wind',
  '🌈': 'rainbow',
  '❄️': 'snowflake',
  '⛄': 'snowman',
  '💧': 'droplet|drop',
  '🌊': 'ocean|wave',
  '🌋': 'volcano',
  '🏔️': 'mountain snow|snow capped mountain',

  // ─── Etel es ital ──────────────────────────────────────────────────────────
  '🍏': 'green apple',
  '🍎': 'apple|red apple',
  '🍐': 'pear',
  '🍊': 'tangerine|orange',
  '🍋': 'lemon',
  '🍌': 'banana',
  '🍉': 'watermelon',
  '🍇': 'grapes',
  '🍓': 'strawberry',
  '🫐': 'blueberries',
  '🍒': 'cherries',
  '🍑': 'peach',
  '🥭': 'mango',
  '🍍': 'pineapple',
  '🥥': 'coconut',
  '🥝': 'kiwi|kiwifruit',
  '🍅': 'tomato',
  '🍆': 'eggplant|aubergine',
  '🥑': 'avocado',
  '🥦': 'broccoli',
  '🥬': 'leafy green|lettuce',
  '🥒': 'cucumber',
  '🌶️': 'hot pepper|chili',
  '🫑': 'bell pepper',
  '🌽': 'corn',
  '🥕': 'carrot',
  '🧄': 'garlic',
  '🧅': 'onion',
  '🥔': 'potato',
  '🍠': 'roasted sweet potato|sweet potato',
  '🥐': 'croissant',
  '🥖': 'baguette bread|baguette',
  '🍞': 'bread',
  '🥨': 'pretzel',
  '🧀': 'cheese',
  '🥚': 'egg',
  '🍳': 'fried egg|cooking',
  '🥞': 'pancakes',
  '🥓': 'bacon',
  '🍗': 'poultry leg|chicken leg',
  '🍖': 'meat on bone|meat',
  '🌭': 'hotdog|hot dog',
  '🍔': 'hamburger|burger',
  '🍟': 'fries|french fries',
  '🍕': 'pizza',
  '🥪': 'sandwich',
  '🌮': 'taco',
  '🌯': 'burrito',
  '🥗': 'green salad|salad',
  '🥘': 'shallow pan of food|paella',
  '🍲': 'stew|pot of food',
  '🍜': 'ramen|noodles',
  '🍝': 'spaghetti|pasta',
  '🍚': 'rice',
  '🍣': 'sushi',
  '🍤': 'fried shrimp',
  '🥟': 'dumpling',
  '🍦': 'icecream|ice cream',
  '🍰': 'cake|shortcake',
  '🎂': 'birthday|birthday cake',
  '🧁': 'cupcake',
  '🍪': 'cookie',
  '🍫': 'chocolate bar|chocolate',
  '🍬': 'candy',
  '🍯': 'honey pot|honey',
  '🥛': 'milk|glass of milk',
  '☕': 'coffee|hot beverage',
  '🫖': 'teapot',
  '🍵': 'tea',
  '🧃': 'beverage box|juice',
  '🥤': 'cup with straw|soda',
  '🍺': 'beer',
  '🍻': 'beers|clinking beer mugs|cheers',
  '🥂': 'clinking glasses|champagne toast',
  '🍷': 'wine glass|wine',
  '🥃': 'tumbler glass|whisky',
  '🍾': 'champagne|bottle with popping cork',
  '🧊': 'ice|ice cube',
  '🍽️': 'fork and knife with plate|dinner',

  // ─── Utazas es helyek ──────────────────────────────────────────────────────
  '🚗': 'car|red car|automobile',
  '🚕': 'taxi',
  '🚙': 'blue car|suv',
  '🚌': 'bus',
  '🚎': 'trolleybus',
  '🏎️': 'racing car',
  '🚓': 'police car',
  '🚑': 'ambulance',
  '🚒': 'fire engine',
  '🚐': 'minibus',
  '🛻': 'pickup truck',
  '🚚': 'truck|delivery truck',
  '🚜': 'tractor',
  '🦽': 'manual wheelchair|wheelchair',
  '🛵': 'motor scooter|scooter',
  '🏍️': 'motorcycle',
  '🚲': 'bike|bicycle',
  '🛴': 'kick scooter',
  '🚂': 'steam locomotive|locomotive',
  '🚆': 'train',
  '🚇': 'metro|subway',
  '🚊': 'tram',
  '✈️': 'airplane|plane',
  '🛫': 'airplane departure|takeoff',
  '🛬': 'airplane arriving|landing',
  '🚁': 'helicopter',
  '⛵': 'sailboat',
  '🚢': 'ship',
  '⛽': 'fuelpump|gas station',
  '🚦': 'vertical traffic light|traffic light',
  '🚧': 'construction|roadblock',
  '🗺️': 'world map|map',
  '🧭': 'compass',
  '🏠': 'house|home',
  '🏡': 'house with garden',
  '🏢': 'office building|office',
  '🏥': 'hospital',
  '🏦': 'bank',
  '🏪': 'convenience store|store',
  '🏫': 'school',
  '🏭': 'factory',
  '🏨': 'hotel',
  '⛪': 'church',
  '🏛️': 'classical building',
  '🏗️': 'building construction',
  '🌇': 'city sunset|sunset',
  '🌃': 'night with stars',
  '🌉': 'bridge at night',
  '🗼': 'tokyo tower|tower',
  '🎡': 'ferris wheel',
  '🏖️': 'beach with umbrella|beach',
  '🏕️': 'camping',
  '⛺': 'tent',
  '🧳': 'luggage',

  // ─── Tevekenyseg es sport ──────────────────────────────────────────────────
  '⚽': 'soccer|football',
  '🏀': 'basketball',
  '🏈': 'american football',
  '⚾': 'baseball',
  '🎾': 'tennis',
  '🏐': 'volleyball',
  '🏉': 'rugby football',
  '🥏': 'flying disc|frisbee',
  '🎱': '8ball|billiards|pool',
  '🏓': 'ping pong|table tennis',
  '🏸': 'badminton',
  '🥅': 'goal net',
  '⛳': 'golf',
  '🏹': 'bow and arrow|archery',
  '🎣': 'fishing pole and fish|fishing',
  '🥊': 'boxing glove|boxing',
  '🥋': 'martial arts uniform',
  '⛸️': 'ice skate|skating',
  '🎿': 'ski',
  '🏂': 'snowboarder|snowboard',
  '🏋️': 'weight lifter|weightlifting',
  '🤸': 'cartwheeling|gymnastics',
  '🤺': 'fencer|fencing',
  '🏊': 'swimmer|swimming',
  '🚴': 'bicyclist|cycling',
  '🧗': 'climbing',
  '🏆': 'trophy',
  '🥇': '1st place medal|gold medal',
  '🥈': '2nd place medal|silver medal',
  '🥉': '3rd place medal|bronze medal',
  '🏅': 'medal|sports medal',
  '🎯': 'dart|bullseye|target',
  '🎲': 'game die|dice',
  '🎮': 'video game|controller',
  '🎰': 'slot machine',
  '🧩': 'puzzle piece|puzzle',
  '🎨': 'art|palette',
  '🎭': 'performing arts|theater',
  '🎬': 'clapper|movie',
  '🎤': 'microphone|mic',
  '🎧': 'headphones',
  '🎵': 'musical note',
  '🎶': 'notes|musical notes',
  '🎸': 'guitar',
  '🎹': 'musical keyboard|piano',
  '🥁': 'drum',
  '🎺': 'trumpet',
  '🎻': 'violin',

  // ─── Munka es targyak ──────────────────────────────────────────────────────
  '💻': 'computer|laptop',
  '🖥️': 'desktop computer|monitor',
  '⌨️': 'keyboard',
  '🖱️': 'computer mouse',
  '🖨️': 'printer',
  '📱': 'iphone|mobile phone|smartphone',
  '☎️': 'telephone|phone',
  '📞': 'telephone receiver|call',
  '📟': 'pager',
  '📠': 'fax',
  '🔋': 'battery',
  '🔌': 'electric plug|plug',
  '💾': 'floppy disk|save',
  '💿': 'cd',
  '📀': 'dvd',
  '🧮': 'abacus',
  '🎥': 'movie camera',
  '📷': 'camera',
  '📹': 'video camera',
  '📺': 'tv|television',
  '📻': 'radio',
  '🔍': 'mag|magnifying glass|search',
  '🔎': 'mag right',
  '💰': 'moneybag|money bag',
  '💵': 'dollar|banknote',
  '💳': 'credit card',
  '🧾': 'receipt',
  '💎': 'gem|diamond',
  '⚖️': 'scales|balance',
  '🔧': 'wrench',
  '🔨': 'hammer',
  '🛠️': 'hammer and wrench|tools',
  '⚙️': 'gear|settings',
  '🧰': 'toolbox',
  '🧲': 'magnet',
  '🪛': 'screwdriver',
  '🔩': 'nut and bolt',
  '🧪': 'test tube',
  '🧬': 'dna',
  '🔬': 'microscope',
  '🔭': 'telescope',
  '📡': 'satellite antenna',
  '💊': 'pill|medicine',
  '💉': 'syringe|injection',
  '🩺': 'stethoscope',
  '🩹': 'adhesive bandage|band aid',
  '🌡️': 'thermometer',
  '🚪': 'door',
  '🪑': 'chair',
  '🛏️': 'bed',
  '🚿': 'shower',
  '🧹': 'broom',
  '🧼': 'soap',
  '🧴': 'lotion bottle',
  '🔑': 'key',
  '🔒': 'lock|locked',
  '🔓': 'unlock|unlocked',
  '🔔': 'bell',
  '🔕': 'no bell|bell with slash|mute',
  '📣': 'mega|megaphone',
  '📢': 'loudspeaker',
  '📝': 'memo|note|pencil',
  '📄': 'page facing up|document',
  '📃': 'page with curl',
  '📑': 'bookmark tabs',
  '📊': 'bar chart',
  '📈': 'chart increasing|chart with upwards trend',
  '📉': 'chart decreasing|chart with downwards trend',
  '📋': 'clipboard',
  '📅': 'date|calendar',
  '📆': 'calendar',
  '🗓️': 'spiral calendar',
  '📇': 'card index',
  '🗂️': 'card index dividers',
  '📁': 'file folder|folder',
  '📂': 'open file folder',
  '🗃️': 'card file box',
  '🗄️': 'file cabinet',
  '🗑️': 'wastebasket|trash|delete',
  '📦': 'package|box',
  '📮': 'postbox',
  '✉️': 'envelope',
  '📧': 'email|e-mail',
  '📨': 'incoming envelope',
  '📤': 'outbox tray|outbox',
  '📥': 'inbox tray|inbox',
  '🔖': 'bookmark',
  '🏷️': 'label|tag',
  '📎': 'paperclip',
  '🖇️': 'linked paperclips',
  '📏': 'straight ruler|ruler',
  '📐': 'triangular ruler',
  '✂️': 'scissors|cut',
  '🖊️': 'pen',
  '🖋️': 'fountain pen',
  '✏️': 'pencil2',
  '🖌️': 'paintbrush',
  '🖍️': 'crayon',
  '📚': 'books',
  '📖': 'open book|book',
  '📓': 'notebook',
  '📔': 'notebook with decorative cover',
  '🗒️': 'spiral notepad|notepad',
  '📰': 'newspaper',
  '🗞️': 'rolled up newspaper',
  '⏰': 'alarm clock',
  '⏱️': 'stopwatch',
  '⏲️': 'timer clock|timer',
  '🕐': 'clock|clock1',
  '⌛': 'hourglass done',
  '🔗': 'link|chains',
  '🕯️': 'candle',
  '🔦': 'flashlight',
  '🪫': 'low battery',
  '🎁': 'gift|present',
  '🎈': 'balloon',
  '🎀': 'ribbon',
  '🧸': 'teddy bear',
  '🪄': 'magic wand',
  '🛎️': 'bellhop bell',

  // ─── Jelek es szimbolumok ──────────────────────────────────────────────────
  '❗': 'exclamation|red exclamation mark',
  '❓': 'question|red question mark',
  '‼️': 'bangbang|double exclamation mark',
  '⁉️': 'interrobang',
  '💯': '100|hundred points|perfect score',
  '🔴': 'red circle',
  '🟠': 'orange circle',
  '🟡': 'yellow circle',
  '🟢': 'green circle',
  '🔵': 'blue circle',
  '🟣': 'purple circle',
  '⚫': 'black circle',
  '⚪': 'white circle',
  '🟥': 'red square',
  '🟧': 'orange square',
  '🟨': 'yellow square',
  '🟩': 'green square',
  '🟦': 'blue square',
  '⬛': 'black large square',
  '⬜': 'white large square',
  '✔️': 'heavy check mark|check mark',
  '☑️': 'ballot box with check',
  '✖️': 'heavy multiplication x|multiply',
  '➕': 'heavy plus sign|plus',
  '➖': 'heavy minus sign|minus',
  '➗': 'heavy division sign|divide',
  '🟰': 'heavy equals sign|equals',
  '♾️': 'infinity',
  '💲': 'heavy dollar sign',
  '💱': 'currency exchange',
  '™️': 'tm|trade mark',
  '©️': 'copyright',
  '®️': 'registered',
  '🔝': 'top',
  '🔜': 'soon',
  '🆕': 'new',
  '🆓': 'free',
  '🆙': 'up',
  '🈵': 'no vacancy',
  '🚫': 'no entry sign|prohibited',
  '⛔': 'no entry',
  '🔞': 'underage|no one under eighteen',
  '☢️': 'radioactive',
  '☣️': 'biohazard',
  '⬆️': 'arrow up',
  '⬇️': 'arrow down',
  '⬅️': 'arrow left',
  '➡️': 'arrow right',
  '↩️': 'leftwards arrow with hook|return',
  '↪️': 'arrow right hook|forward',
  '🔄': 'arrows counterclockwise|refresh',
  '🔃': 'arrows clockwise',
  '▶️': 'arrow forward|play',
  '⏸️': 'pause button|pause',
  '⏹️': 'stop button|stop',
  '⏺️': 'record button|record',
  '⏭️': 'next track button|next',
  '⏮️': 'previous track button|previous',
  '⏩': 'fast forward',
  '🔀': 'twisted rightwards arrows|shuffle',
  '🔁': 'repeat',
  '🔊': 'loud sound|speaker high volume',
  '🔉': 'sound|speaker medium volume',
  '🔈': 'speaker|speaker low volume',
  '🔇': 'mute|muted speaker',
  '🎙️': 'studio microphone',
  '📶': 'signal strength',
  '📳': 'vibration mode',
  '♻️': 'recycle',
  '⚜️': 'fleur de lis',
  '🔱': 'trident',
  '⭕': 'o|heavy large circle',
  '❤️‍🔥': 'heart on fire',
  '🧡': 'orange heart',
  '💛': 'yellow heart',
  '💚': 'green heart',
  '💙': 'blue heart',
  '💜': 'purple heart',
  '🖤': 'black heart',
  '🤍': 'white heart',
  '🤎': 'brown heart',
  '💔': 'broken heart',
  '💕': 'two hearts',
  '💖': 'sparkling heart',
  '💗': 'heartpulse|growing heart',
  '💘': 'cupid|heart with arrow',
  '💝': 'gift heart|heart with ribbon',
  '💤': 'zzz|sleeping',
  '💬': 'speech balloon|speech',
  '🗨️': 'left speech bubble',
  '🗯️': 'right anger bubble',
  '💭': 'thought balloon',
  '🏳️': 'white flag',
  '🏴': 'black flag',
  '🏁': 'checkered flag',
  '🚩': 'triangular flag',
  '🇭🇺': 'hungary|flag hungary',
  '🇪🇺': 'european union|flag eu',
};
